import type { FunctionComponent } from "react";

import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";
import { useHomepageLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledScmpLogoFlag } from "./styles";

export type HeaderFeaturesLogoLinkProps = {
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesLogoLink: FunctionComponent<HeaderFeaturesLogoLinkProps> = ({
  shouldSwap,
  showIn,
  showOnSwap,
}) => {
  const homepageLogoLinkProps = useHomepageLogoLinkProps();

  return (
    <Container $shouldSwap={shouldSwap} $showIn={showIn} $showOnSwap={showOnSwap}>
      <StyledLogoLink {...homepageLogoLinkProps}>
        <StyledScmpLogoFlag />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesLogoLink.displayName = "HeaderFeaturesLogoLink";
